"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "THEME": "Allianz",
    "TRADEMARK": "This insurance is arranged, underwritten and administered by Liverpool Victoria Insurance Company Limited, which is an Allianz Group company, registered in England and Wales number 3232514. Authorised by the Prudential Regulation Authority and regulated by the Financial Conduct Authority and the Prudential Regulation Authority, register number 202965. Registered address: 57 Ladymead, Guildford, Surrey, GU1 1DB. Allianz Online is a trading name of Liverpool Victoria Insurance Company Limited.",
    "WHATEVER_YOU_DECIDE": "Whatever you decide, we’ll make it happen.",
    "COMPLAINT_EMAIL": "digitalhelp@allianz.co.uk",
    "HELP_EMAIL": "digitalhelp@allianz.co.uk",
    "UNDERWRITER": "underwritten by Liverpool Victoria Insurance Company Limited, which is an Allianz Group company",
    "FAQ_CAR_URL": "https://www.allianz.co.uk/insurance/car-insurance/faqs.html",
    "FAQ_HOME_URL": "https://www.allianz.co.uk/insurance/home-insurance/faqs.html",
    "CONTACT_US_URL": "https://www.allianz.co.uk/insurance/car-insurance/contact-us.html",
    "PRIVACY_NOTICE_URL": "https://www.allianz.co.uk/privacy-notice.html",
    "LEGAL_NOTICE_URL": "",
    "COOKIE_POLICY_URL": "https://www.allianz.co.uk/cookie-policy.html",
    "PRODUCT": "Allianz Online",
    "TIER_1": "Bronze",
    "TIER_2": "Silver",
    "TIER_3": "Gold",
    "PRODUCT_TIER_1": "Allianz Online Bronze",
    "PRODUCT_TIER_2": "Allianz Online Silver",
    "PRODUCT_TIER_3": "Allianz Online Gold",
    "CREDIT_WORDING": "Credit supplied by Liverpool Victoria Insurance Company Limited, which is an Allianz Group company",
    "MOTOR_CLAIMS_WINDSCREEN_PHONE_DISPLAY": "0330 678 5557",
    "MOTOR_CLAIMS_WINDSCREEN_PHONE_TEL": "tel:03306785557",
    "MOTOR_CLAIMS_WINDSCREEN_PHONE_ABROAD_DISPLAY": "(+44) 0120 284 8509",
    "MOTOR_CLAIMS_WINDSCREEN_PHONE_ABROAD_TEL": "tel:+441202848509",
    "MOTOR_CLAIMS_BREAKDOWN_PHONE_DISPLAY": "0330 678 7112",
    "MOTOR_CLAIMS_BREAKDOWN_PHONE_TEL": "tel:03306787112",
    "MOTOR_CLAIMS_BREAKDOWN_PHONE_ABROAD_DISPLAY": "(+44) 01202 295398",
    "MOTOR_CLAIMS_BREAKDOWN_PHONE_ABROAD_TEL": "tel:+441202295398",
    "BRAND_URL": "https://www.allianz.co.uk",
    "LET_US_KNOW_URL": "https://cloud.comms.allianz.co.uk/RenewalDateCapture",
    "HOW_TO_VIDEOS": undefined,
    "DOCUMENTS_TITLE": "Documents and Communications"
};
//# sourceMappingURL=resource.js.map